import React from "react"
import { useLocation, Navigate } from 'react-router-dom';
import { useAuthenticator } from '@aws-amplify/ui-react';
import ErrorBoundary from "../ErrorBoundary/ErrorBoundary";

export function RequireAuth({ children }:{children:JSX.Element}) {
  const location = useLocation();
  const { route } = useAuthenticator((context) => [context.route]);
  if (route !== 'authenticated') {
    return <Navigate to="/" state={{ from: location }} replace />;
  }
  return <ErrorBoundary>{children}</ErrorBoundary>;
}